import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateText',
    pure: false
})

export class TranslateTextPipe implements PipeTransform {
    transform(value: any, table: any, key: string, displayText: string) {
        let result: string = value;
        if(table !== undefined)
        {
            table.forEach(element => {
                if (value === element[key]) {
                    result =  element[displayText];
                }
            });
        }
        return result;
    }
}
